import React, { useEffect, useState } from "react";
import Tour from "reactour";
import { useSelector } from "react-redux";
import "./style.scss";
import { TOUR_DOC, TOUR_DOC_VAM } from "./TourSteps";

export const TourStart = ({ type, hide, title, hideTitle, auto }) => {
    const user = useSelector(state => state.user);

    const [open, setOpen] = useState(false);
    const [steps, setSteps] = useState([{}]);

    const closeTour = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (auto) {
            openSteps();
        }
    }, [type, user, auto]);

    function openSteps() {
        setOpen(true);
        const _steps = get_steps(type);
        setSteps(_steps);
    }

    return (
        <>
            {open && (
                <Tour
                    steps={steps}
                    isOpen={open}
                    onRequestClose={closeTour}
                    closeWithMask={true}
                    disableInteraction={true}
                />
            )}
            <div
                onClick={() => setOpen(!open)}
                title={title}
                className={hide ? "d-none" : "d-inline actions"}
                style={{ color: "white" }}
            >
                <i className="fas" id={`btn-help-${type}`} data-open={open}>
                    <i className={"fas fa-question-circle"} title={"Ayuda"} onClick={() => openSteps()} />
                </i>
                {title && !hideTitle && <span className={"mx-0 px-0"}>{title}</span>}
            </div>
        </>
    );
};

const get_steps = type => {
    switch (type) {
        case "documentos":
            return TOUR_DOC;
        case "documentos-vam":
            return TOUR_DOC_VAM;
        default:
            break;
    }
};
